import { SESSION_STORAGE_KEY } from '../common/constants/constants'
import { TREATMENT_OPTIONS, type TREATMENT_OPTIONS_TYPE } from '../common/constants/treatmentOptions'

const validTreatmentOptions = new Set<string>(Object.values(TREATMENT_OPTIONS))

export const getStoredHomebaseAnalyticsTreatmentOption = (): TREATMENT_OPTIONS_TYPE | null => {
  if (typeof window === 'undefined') return null

  try {
    const storedValue = window.sessionStorage.getItem(SESSION_STORAGE_KEY.HOMEBASE_ANALYTICS_TREATMENT_OPTION)
    if (storedValue == null) return null
    if (validTreatmentOptions.has(storedValue)) return storedValue as TREATMENT_OPTIONS_TYPE

    window.sessionStorage.removeItem(SESSION_STORAGE_KEY.HOMEBASE_ANALYTICS_TREATMENT_OPTION)
    return null
  } catch {
    return null
  }
}

export const storeHomebaseAnalyticsTreatmentOption = (treatmentOption: unknown): void => {
  if (typeof window === 'undefined' || typeof treatmentOption !== 'string') return
  if (!validTreatmentOptions.has(treatmentOption)) return

  try {
    window.sessionStorage.setItem(SESSION_STORAGE_KEY.HOMEBASE_ANALYTICS_TREATMENT_OPTION, treatmentOption)
  } catch {
    // Tracking context is best-effort when session storage is unavailable.
  }
}

export const clearStoredHomebaseAnalyticsTreatmentOption = (): void => {
  if (typeof window === 'undefined') return

  try {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY.HOMEBASE_ANALYTICS_TREATMENT_OPTION)
  } catch {
    // Tracking context is best-effort when session storage is unavailable.
  }
}
